import { Bell, Building2 } from "lucide-react";
import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useFilters } from "@/context/FiltersContext";
import { api } from "@/lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import {
  Popover, PopoverContent, PopoverTrigger,
} from "@/components/ui/popover";

export default function TopBar() {
  const { user } = useAuth();
  const { executives, selectedExecId, setSelectedExecId } = useFilters();
  const [overdue, setOverdue] = useState([]);

  useEffect(() => {
    api.get("/dashboard/summary").then((r) => {
      setOverdue(r.data.overdue_list || []);
    }).catch(() => {});
  }, []);

  const canPickExec = user?.role !== "executive";

  return (
    <header className="h-16 flex items-center justify-between px-6 sticky top-0 z-40
                       backdrop-blur-xl bg-[#0F172A]/90 border-b border-slate-800"
      data-testid="app-topbar">
      <div className="flex items-center gap-4">
        <h1 className="text-white text-lg font-semibold" style={{ fontFamily: "Outfit" }}>
          Field Marketing Command Center
        </h1>
      </div>
      <div className="flex items-center gap-3">
        <div className="hidden sm:flex items-center gap-2 text-xs text-slate-400 bg-slate-800/40 px-3 py-1.5 rounded-lg border border-slate-800">
          <Building2 size={13} /> Delhi HQ
        </div>

        {canPickExec && (
          <Select value={selectedExecId} onValueChange={setSelectedExecId}>
            <SelectTrigger
              data-testid="topbar-exec-select"
              className="w-48 bg-slate-900 border-slate-700 text-white h-9"
            >
              <SelectValue placeholder="All executives" />
            </SelectTrigger>
            <SelectContent className="bg-[#0F172A] border-slate-700 text-white">
              <SelectItem value="all">All Executives</SelectItem>
              {executives.map((e) => (
                <SelectItem key={e.id} value={e.id}>{e.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}

        <Popover>
          <PopoverTrigger asChild>
            <button
              data-testid="btn-notifications"
              className="relative p-2 rounded-lg bg-slate-800/60 hover:bg-slate-700 transition-colors"
            >
              <Bell size={17} className="text-slate-200" />
              {overdue.length > 0 && (
                <span className="absolute -top-1 -right-1 min-w-5 h-5 px-1 rounded-full text-[10px] bg-[#DC2626] text-white flex items-center justify-center font-bold">
                  {overdue.length}
                </span>
              )}
            </button>
          </PopoverTrigger>
          <PopoverContent align="end" className="w-80 bg-[#0F172A] border-slate-700 text-white p-0">
            <div className="p-3 border-b border-slate-800 text-xs uppercase tracking-wider text-slate-400">
              Overdue Follow-Ups
            </div>
            <div className="max-h-72 overflow-y-auto">
              {overdue.length === 0 ? (
                <div className="p-4 text-sm text-slate-400">No overdue follow-ups. 🎉</div>
              ) : overdue.map((t) => (
                <div key={t.id} className="p-3 border-b border-slate-800 text-sm">
                  <div className="text-white font-medium">{t.organisation_name}</div>
                  <div className="text-xs text-slate-400 mt-0.5">
                    {t.tieup_type} • Follow-up due {t.follow_up_date}
                  </div>
                </div>
              ))}
            </div>
          </PopoverContent>
        </Popover>
      </div>
    </header>
  );
}
